import React , {Component} from 'react'
import Info from './info';
import Clock from 'react-live-clock';
 
export default class ClockItem extends Component{
    constructor(props){
        super(props);
        this.state = {
            countryName : this.props.countryName,
            data : {
                iran : {
                    location : 'Asia/Tehran',
                    name : 'ایران - تهران',
                    flag : '/uploads/ir_flag_e86aaccbcf.svg'
                },
                usa : {
                    location : 'America/New_York',
                    name : 'آمریکا - نیویورک',
                    flag : '/uploads/us_flag_a558b8e6f5.svg'
                },
                arabEmirates : {
                    location : 'Asia/Dubai',
                    name : 'امارات - دبی',
                    flag : '/uploads/ea_flag_1768e15223.svg'
                },
                china : {
                    location : 'Asia/Shanghai',
                    name : 'چین - شانگهای',
                    flag : '/uploads/ch_flag_6858fe07b3.svg'
                },
                england : {
                    location : 'Europe/London',
                    name : 'انگلیس - لندن',
                    flag : '/uploads/en_flag_e83b8fb96d.svg'
                },
                iraq : {
                    location : 'Asia/Baghdad',
                    name : 'عراق - بغداد',
                    flag : '/uploads/iq_flag_8bdae145f3.svg'
                },
                sweden : {
                    location : 'Europe/Stockholm',
                    name : 'سوئد - استوکهلم',
                    flag : '/uploads/sw_flag_5523908539.svg'
                },
                turkey : {
                    location : 'Asia/Istanbul',
                    name : 'ترکیه - استامبول',
                    flag : '/uploads/tk_flag_6aa6753cae.svg'
                },
            }
        }
    }
    render(){
        return(
            <div className="clockItem">
                <div className="clockItemInner">
                    <div className="clockFlag">
                        <img src={Info.UPLOADS_URL + this.state.data[this.state.countryName].flag} alt="flag"/>
                    </div>
                    <div className="clockTextWrapper">
                        <p className="cityName">
                            {this.state.data[this.state.countryName].name}
                        </p>
                        <div className="mainTime">
                        <span>
                        <Clock
                            format={'HH:mm:ss'}
                            ticking={true}
                            timezone={this.state.data[this.state.countryName].location} 
                        />
                       </span>
                       </div>
                    </div>
                </div>
            </div>
        )
    }
}